import { render, staticRenderFns } from "./AggregationsTable.vue?vue&type=template&id=a0e54a7c&scoped=true&"
import script from "./AggregationsTable.vue?vue&type=script&lang=js&"
export * from "./AggregationsTable.vue?vue&type=script&lang=js&"
import style0 from "./AggregationsTable.vue?vue&type=style&index=0&id=a0e54a7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0e54a7c",
  null
  
)

export default component.exports